/**
 * Ideally connector — single source of truth for all Ideally metadata.
 *
 * SVG: Ideally's logo is not publicly available in any icon library.
 * To add the real logo: download the SVG from https://ideally.com, extract
 * the path d value, and set it here.
 * Brand color confirmed from ideally.com CSS: #116DFF.
 */

module.exports = {
  id:          'ideally',
  name:        'Ideally',
  enabled:     false,
  iconBg:      '#116DFF',
  svgPath:     null, // TODO: source from Ideally brand kit

  tagline:     'Pull continuous discovery insights and feedback into agent context.',
  description: 'Connect Ideally so agents can read continuous discovery outputs, user feedback, and research patterns when evaluating strategic direction and product fit.',
  useCases: [
    'Surface continuous discovery findings when agents plan strategy',
    'Pull user feedback patterns into opportunity assessments',
    'Ground strategic decisions in ongoing discovery evidence',
  ],
};
